import { frontendURL } from '../../../../helper/URLHelper';
import SettingsWrapper from '../SettingsWrapper.vue';

const KnowledgeBasesIndex = () => import('./Index.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/knowledge-bases'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          name: 'settings_knowledge_bases',
          component: KnowledgeBasesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
